import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'src/app/globals';
import { CoursesService } from '../../../service/courses.service';
import { ToastrService } from 'ngx-toastr';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { AcademicsService } from 'src/app/service/academics.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-semester-student-grouping',
  templateUrl: './semester-student-grouping.component.html',
  styleUrls: ['./semester-student-grouping.component.scss']
})
export class SemesterStudentGroupingComponent implements OnInit {
  showLoader: boolean = false;
  erlGroups: any = [];
  dtOptions: DataTables.Settings = {};
  orgId: any;
  username: any;
  activeCourses: any = [];
  constructor(private academicsService: AcademicsService, private toastrService: ToastrService, public coursesService: CoursesService, public globals: Globals, private router: Router
    , public translate: TranslateService) { }

  ngOnInit(): void {
    this.orgId = this.globals.currentUserInfo.orgid;
    this.username = this.globals.currentUserInfo.username;
    this.erlGroups = [];
    this.showLoader = true;
    this.getAllErlGroups2();
    this.showLoader = false;
  }


  // getAllErlGroups() {
  //   this.showLoader = true;
  //   this.getAciveCourses();
  //   this.academicsService.getAllErlGroups()
  //     .subscribe(
  //       data => {
  //         this.erlGroups = data;
  //         //loop to get course from activecourses list
  //         for (let i = 0; i < this.erlGroups.length; i++) {
  //           let subjectId=this.erlGroups[i].subjectid;
  //           let filtered = this.activeCourses.filter((value: any) => value.id==subjectId)[0];
  //             if ( typeof(filtered) != 'undefined')
  //             {
  //             this.erlGroups[i].subjectNameAr = filtered.subjectNameAr;
  //             this.erlGroups[i].subjectNameEn = filtered.subjectNameEn;;
  //             }        
  //         }
  //         this.updateTable();
  //       },
  //       error => {

  //         this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
  //         this.showLoader = false

  //       },
  //       () => this.showLoader = false
  //     );
  // }

  updateTable() {
    $("#datatable").DataTable().destroy();
    setTimeout(() => {
      $("#datatable").DataTable({
        dom: 'Bfrtip',
        pagingType: 'simple_numbers',
        // responsive: true,
        // columnDefs: [
        //   { responsivePriority: 1, targets: 0 },
        //   { responsivePriority: 10001, targets: 4 },
        //   { responsivePriority: 2, targets: -2 }
        // ],
        // "columnDefs": [
        //   { "orderable": false, "targets": [1, 2] }
        // ],
        pageLength: 5,
        lengthChange: false,
        info: true,
        search: {
          searchPlaceholder: "Search",
        },
        paging: true,
        language: {
          search: "",
          searchPlaceholder: "Search"
        },
        // buttons: [{
        //   extend: 'excelHtml5',
        //   text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
        //   titleAttr: 'enarabic',
        //   exportOptions: {
        //     columns: [0, 1, 2, 3, 4, 5, 6]
        //   }
        // }],
      });
    }, 1);
    // $("#datatable").DataTable().buttons().disable();
  }

  getAciveCourses() {
    this.academicsService.getActiveSubjectList(this.orgId).subscribe(
      data => {
        this.activeCourses = data;
        console.log(this.activeCourses);
      },
      error => {
        this.toastrService.error(this.translate.instant("CAN_NOT_GET_DATA_BE"));
        this.showLoader = false;
      }
    );
  }


  getAllErlGroups2() {
    let bulkApis = [
      this.academicsService.getActiveSubjectList(this.orgId),
      this.academicsService.getAllErlGroups()
    ];

    forkJoin(bulkApis).subscribe(
      data => {
        if (typeof data[0] != undefined)
          this.activeCourses = data[0];
        if (typeof data[1] != undefined) {
          this.erlGroups = data[1];
          this.erlGroups.map((element: any) => {
            let subjectid = element.subjectid;
            let course = this.activeCourses.filter((i: any) => i.id == subjectid)[0];
            if (typeof (course) != 'undefined') {
              element.subjectNameAr = course.subjectNameAr;
              element.subjectNameEn = course.subjectNameEn;
            }
            // return { ...element, course };
          });
          this.updateTable();
        } else {
          this.toastrService.warning(this.translate.instant("NO_DATA_FOUND"));
        }
        this.showLoader = false;
      },
      error => {
        this.toastrService.error(this.translate.instant("CAN_NOT_GET_DATA_BE"));
        this.showLoader = false;
      }
    );
  }
}